import { render } from "./agence.vue?vue&type=template&id=dd9bf78a&scoped=true"
import script from "./agence.vue?vue&type=script&lang=js"
export * from "./agence.vue?vue&type=script&lang=js"

import "./agence.vue?vue&type=style&index=0&id=dd9bf78a&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd9bf78a"]])

export default __exports__